/**
 * @fileoverview Formata um telefone para exibição. Número brasileiro com DDI
 * (55 + DDD + 8 ou 9 dígitos) vira "+55 (51) 99196-0344"; qualquer outro volta
 * como veio (estrangeiro, grupo, identificador do LiveChat, texto livre).
 */

// Só dígitos e a pontuação comum de telefone: "lc-3f9a…" ou um e-mail não passam.
const LOOKS_LIKE_PHONE = /^\+?[\d\s().-]+$/;

export const formatPhoneNumber = (raw) => {
  const original = raw == null ? "" : String(raw);
  if (!LOOKS_LIKE_PHONE.test(original.trim())) return original;
  const br = original.replace(/\D/g, "").match(/^55(\d{2})(\d{4,5})(\d{4})$/);
  return br ? `+55 (${br[1]}) ${br[2]}-${br[3]}` : original;
};
